import React from 'react';

const IconDiv = ({classes, path, url}) => {
    return (
        <div className={classes} style={{backgroundImage: `url(${(path && path + url) || url})`, backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover'}}/>
    );
};

export default IconDiv;
